export default {
  default: () => import("/github/workspace/layouts/default.vue").then(m => m.default || m),
  sidebar: () => import("/github/workspace/layouts/sidebar.vue").then(m => m.default || m)
}